
import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { EditPatternOption } from '@/model'
import { Product } from '@/model/product'

export default Vue.extend({
  components: {
    ModalOverlay
  },
  props: {
    product: {
      type: Object as () => Product,
      required: true
    },
    selectedEditPattern: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentEditPattern: this.selectedEditPattern
    }
  },
  mounted() {
    document.querySelector('body')!.classList.add('is-locked')
  },
  destroyed: function() {
    document.querySelector('body')!.classList.remove('is-locked')
  },
  methods: {
    updateCurrentEditPattern(editPattern: EditPatternOption) {
      this.currentEditPattern = editPattern
    },
    onUpdateSelectedEditPattern() {
      this.$emit('update', this.currentEditPattern)
    },
    onCloseModal() {
      this.$emit('close')
    }
  }
})
